/**
 * @fileoverview GET handler for the "/integrations/scim/scim_info" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsScimScimInfo } from "./constants";
import type { IntegrationsScimScimInfoResult } from "./types";
import { isIntegrationsScimScimInfoResult } from "./validators";

export const getIntegrationsScimScimInfo = reactQueryFetcherAdapter(
  integrationsScimScimInfo,
  (signal: AbortSignal): Promise<IntegrationsScimScimInfoResult> => {
    return fetch("/integrations/scim/scim_info", "GET", {}, { signal });
  },
  isIntegrationsScimScimInfoResult
);
